import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import { AccountUserInputDto, AccountUserOutputDto, AccountUserOutputDtoSingleOutputMessage } from '@types';

export const useFetchAccountUser = (): UseFetchHookOutput<AccountUserInputDto, AccountUserOutputDto> => {
	const { accountUser: fetchAccountUser } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountUserInputDto, AccountUserOutputDto>({
		input: {
			fetchFn: fetchAccountUser,
			onSuccess: (res: AccountUserOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountUser: res.data });
			},
		},
		showGenericErrorModal: false,
		requestName: 'account/user',
	});
};
